module.exports = __webpack_public_path__ + "media/dashboard/assets/images/contact-socials/twitter-e3b6c8da4f45dcf28772c610d880925b.svg";